module.exports = __webpack_public_path__ + "img/bg_m.87f2d805.jpg";